import { HotTopic } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromDesignerService } from './fetchFromDesignerService';

export const fetchHotTopics = () =>
  fetchFromDesignerService<Record<string, HotTopic[]>>('hottopics').then(
    (data) => data[getParams().locale]
  );
